import { createI18n } from 'vue-i18n'

// 从 localStorage 中获取保存的语言设置，如果没有则默认使用 'en'
const savedLocale = localStorage.getItem('locale') || 'en'

// 懒加载语言文件映射
const languageModules = {
  zh: () => import('./locales/zh.js'),
  en: () => import('./locales/en.js'),
  jp: () => import('./locales/jp'),
  kr: () => import('./locales/kr'),
  ru: () => import('./locales/ru'),
  fr: () => import('./locales/fr'),
  gr: () => import('./locales/gr'),
  sp: () => import('./locales/sp'),
  sw: () => import('./locales/sw'),
  pt: () => import('./locales/pt')
}

export const i18n = createI18n({
  locale: savedLocale,
  legacy: false,
  messages: {} // 初始为空，按需加载
})

// 加载语言文件的函数
export async function loadLanguageAsync(lang) {
  // 如果已经加载过该语言，直接返回
  if (i18n.global.availableLocales.includes(lang)) {
    i18n.global.locale.value = lang
    return Promise.resolve()
  }

  // 动态加载语言文件
  if (languageModules[lang]) {
    const messages = await languageModules[lang]()
    i18n.global.setLocaleMessage(lang, messages.default)
    i18n.global.locale.value = lang
    return Promise.resolve()
  }

  return Promise.reject(new Error(`Language ${lang} not found`))
}

// 初始化时加载保存的语言
loadLanguageAsync(savedLocale)
